import React from 'react';
import { Button, Form, Input } from 'antd';
const FormItem = Form.Item;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 6
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 14
    }
  }
};

const UpdateKRForm = Form.create()((props) => {
  const {
    visible,
    onCancel,
    onCreate,
    form,
    kr
  } = props;
  const { getFieldDecorator } = form;
  return (
    <Form>
      <FormItem {...formItemLayout} label="标题">
        <span>{kr.title}</span>
        {/* {getFieldDecorator('title', {
          rules: [
            {
              required: true,
              message: '请输入标题！'
            }
          ],
          initialValue: kr.title
        })(<Input />)} */}
      </FormItem>
      <FormItem {...formItemLayout} label="目标值">
        <span>{kr.endValue}</span>
        {/* {getFieldDecorator('weightE2', {
          rules: [
            {
              required: true,
              message: '请输入数值！',
              max: 100
            }
          ],
          initialValue: kr.weightE2.toString()
        })(<Input type="number" />)} */}
      </FormItem>
      <FormItem {...formItemLayout} label="当前值">
        {getFieldDecorator('currentValue', {
          rules: [
            {
              required: true,
              message: '请输入当前值！',
              max: 100
            }
          ],
          initialValue: kr.currentValue
        })(<Input type="number" />)}
      </FormItem>
      <FormItem {...formItemLayout} label="描述">
        {getFieldDecorator("description", {
          initialValue: kr.description
        })(<Input type="textarea" autosize={{ minRows: 3, maxRows: 4 }} />)}
      </FormItem>
    </Form>
  )
})
export default UpdateKRForm;


// WEBPACK FOOTER //
// ./src/components/okr_manage/update_kr_form.js